<template>
  <div class="d-flex align-center relative">
    <v-select
      :value="selectedFilters.changeType"
      :items="filtersOptions.commercialPrintChangeTypes"
      placeholder="Typ zmiany"
      v-bind="props.select"
      class="mr-2 width-180"
      @input="selectToggleFilter({ changeType: $event })"
    />

    <v-menu
      ref="datePicker"
      v-model="isDatePickerShown"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      z-index="11"
      max-width="290"
      min-width="290"
    >
      <template #activator="{ on, attrs }">
        <div v-on="on">
          <v-text-field
            :value="dateFormatted"
            persistent-hint
            v-bind="{ ...attrs, ...props.shortTextField }"
            readonly
            hide-details
            placeholder="Data rozp."
            class="input-calendar width-140"
            append-icon="mdi-calendar-month-outline"
          />
        </div>
      </template>

      <v-date-picker
        v-model="date"
        v-bind="props.datePicker"
        range
        :title-date-format="() => dateFormatted"
        @input="filterElements({ daterange: $event.sort() })"
      />
    </v-menu>
    <v-btn
      v-if="filtersActive"
      text
      class="primary--text clear-filters-button ml-2"
      @click="clearAllFilters"
    >
      Wyczyść filtry
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import utils from '@/helpers/utils';
import props from '@/helpers/componentsProps';

export default {
  data() {
    return {
      props,
      date: [],
      isDatePickerShown: false,
    };
  },

  computed: {
    ...mapState(['isLoading']),

    ...mapState('filters', ['selectedFilters', 'filtersOptions']),

    dateFormatted() {
      return utils.formatDateOutput(this.date);
    },

    filtersActive() {
      return utils.areFiltersSet(this.selectedFilters);
    },
  },

  methods: {
    ...mapActions('filters', ['setFilters', 'clearFilters']),

    selectToggleFilter(filterObject) {
      utils.checkIfFilterExists(filterObject, this.selectedFilters, this.filterElements);
    },

    filterElements(filterObject) {
      this.setFilters(filterObject).then(() => {
        this.$emit('search');
      });
    },

    clearAllFilters() {
      this.date = [];
      this.clearFilters().then(() => {
        this.$emit('search');
      });
    },
  },
};
</script>
